<template>
    <main class="brand-page-background not-found-page min-h-screen p-3 md:p-5">
        <div class="not-found-shell brand-page-shell p-4 md:p-5 flex flex-column">
            <div class="flex justify-content-center">
                <picture class="flex justify-content-center">
                    <source :srcset="notFoundDarkImage" media="(prefers-color-scheme: dark)" />
                    <img
                        :src="notFoundLightImage"
                        alt="404 page illustration"
                        class="not-found-image"
                    />
                </picture>
            </div>

            <div class="mt-2">
                <div class="flex justify-content-center mt-4">
                    <Button label="Back" severity="contrast" variant="outlined" @click="back()" />
                </div>
            </div>
        </div>
    </main>
</template>

<script setup>
import { useRouter } from 'vue-router'
import notFoundDarkImage from '@/assets/img/404-dark.svg'
import notFoundLightImage from '@/assets/img/404-light.svg'

const router = useRouter()

const back = () => {
    router.back()
}
</script>

<style scoped>
.not-found-shell {
}

.not-found-image {
    max-width: min(460px, 100%);
    width: 100%;
    height: auto;
    display: block;
}
</style>
